"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandlerType = void 0;
var HandlerType;
(function (HandlerType) {
    /*
     * The Legacy Handler uses message persistence (when enabled for the environment)
     * and outboxing of messages. The message persistence is known to not reliably prevent double-handling
     * and can cause outboxed messages to be dropped if outbox.flush is running while
     * a process is terminated
     */
    HandlerType["Legacy"] = "Legacy";
    /*
     * The OutboxOnly Handler is similar to Legacy except it has no message persistence strategy.
     * A message sent with OutboxOnly can be expected to be handled more than once, so the Handler
     * must be idompotent. This handler prevents dropped messages associated with the interaction between
     * message persistence and outboxing
     */
    HandlerType["OutboxOnly"] = "OutboxOnly";
    /*
     * The NativeSqs Handler has neither message persistence or outboxing. It is simply a wrapper around SQS
     */
    HandlerType["NativeSqs"] = "NativeSqs";
})(HandlerType || (exports.HandlerType = HandlerType = {}));
